import React, { useEffect, useState, useRef } from "react";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import DSBAlogo from "../../Images/DSBAlogo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import htmlToXlsx from "html-to-xlsx";
import { RootState } from "../../store/store";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { IEvent } from "../../store/eventApiSlice";
import ReportServices from "../../services/ReportServices";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface Iprops {
  callBackClose: () => void;
}

const FuncAttendanceReport: React.FC<Iprops> = (props) => {
  const BeforeReportRef = useRef<HTMLDivElement>(null);
  const AfterReportRef = useRef<HTMLDivElement>(null);

  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  const [eventState, setEventState] = useState<string>(
    eventInfo.StartDateTime && dayjs(eventInfo.StartDateTime) > dayjs()
      ? "Before"
      : "After"
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [funcAttendanceReportBeforeEvent, setFuncAttendanceReportBeforeEvent] =
    useState<any>();
  const [funcAttendanceReportAfterEvent, setFuncAttendanceReportAfterEvent] =
    useState<any>();

  const [IsActiveDataLoaded, setIsActiveDataLoaded] = useState<boolean>(false);

  useEffect(() => {
    const getFuncAttendanceReportBeforeEvent = async () => {
      setIsActiveDataLoaded(true);
      try {
        const response =
          await ReportServices.getFuncAttendanceReportBeforeEvent(
            eventInfo.Id!
          );
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log(
            "Success-getOrderByMemberId:",
            response.data.data.ParticipantsInfo
          );
          setFuncAttendanceReportBeforeEvent(
            response.data.data.ParticipantsInfo
          );
          setIsActiveDataLoaded(false);
        } else {
          setIsActiveDataLoaded(false);
        }
      } catch (error) {
        setIsActiveDataLoaded(false);
      }
    };

    const getFuncAttendanceReportAfterEvent = async () => {
      setIsActiveDataLoaded(true);
      try {
        const response = await ReportServices.getFuncAttendanceReportAfterEvent(
          eventInfo.Id!
        );
        if (response.data.data != null) {
          if (response.data.hasErrors) {
            setShowAlertModal(true);
            setAlertTitle("Database Error");
            setAlertBody(response.data.errors[0].sqlMessage);
            return;
          }
          console.log(
            "Success-getOrderByMemberId:",
            response.data.data.ParticipantsInfo
          );
          setFuncAttendanceReportAfterEvent(
            response.data.data.ParticipantsInfo
          );
          setIsActiveDataLoaded(false);
        } else {
          setIsActiveDataLoaded(false);
        }
      } catch (error) {
        setIsActiveDataLoaded(false);
      }
    };

    if (eventState === "Before") {
      getFuncAttendanceReportBeforeEvent();
    } else if (eventState === "After") {
      getFuncAttendanceReportAfterEvent();
    }
  }, [eventState]);

  const handlePrint = useReactToPrint(
    eventState === "Before"
      ? {
          content: () => BeforeReportRef.current,
        }
      : {
          content: () => AfterReportRef.current,
        }
  );

  const handleExport = async () => {
    const ws = XLSX.utils.table_to_sheet(
      ( eventState === "Before" ? BeforeReportRef.current : AfterReportRef.current ) );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = "AttendanceReport.xlsx";
    if (eventInfo?.UniqueEventId) {
      fileName = `${eventInfo.UniqueEventId}_AttendanceReport_${eventState}.xlsx`;
    }
    saveAs(blob, fileName);
  };

  return (
    <>
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ alignItems: "center" }}
      >
        <h1 className="page-heading" style={{ height: "auto" }}>
          Function Attendance Report
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div key="EventState" className="checkboxgroup">
            <input
              id="Before Event"
              className="checkbox"
              type="checkbox"
              checked={eventState === "Before" ? true : false}
              onChange={() => setEventState("Before")}
            />
            <span
              style={{
                marginRight: "3rem",
                fontSize: "1.25rem",
                fontWeight: "500",
              }}
            >
              Before Event
            </span>
          </div>
          <div key="EventState" className="checkboxgroup">
            <input
              id="After Event"
              className="checkbox"
              type="checkbox"
              checked={eventState === "After" ? true : false}
              onChange={() => setEventState("After")}
            />
            <span
              style={{
                marginRight: "3rem",
                fontSize: "1.25rem",
                fontWeight: "500",
              }}
            >
              After Event
            </span>
          </div>
        </div>
        <div
          className="horizontal-wrapper-rightaligned"
          style={{
            width: "auto",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          <SecondaryWhiteButton
            className="button-wrapper"
            type="button"
            style={{
              marginRight: ".5rem",
              marginLeft: ".5rem",
            }}
            onClick={() => handleExport()}
            // onClick={() => handlePrint()}
          >
            <span style={{ fontWeight: "500" }}>Print / Download</span>
          </SecondaryWhiteButton>
          <PageLink
            onClick={props.callBackClose}
            // style={{ marginBottom: "2rem" }}
          >
            Close
          </PageLink>
        </div>
        {eventState === "Before" ? (
          <div className="section-box" ref={BeforeReportRef}>
            <div
              className="grid-report-header-container"
              style={{ alignItems: "center", marginBottom: "2rem" }}
            >
              <div>
                <img className="logo-img " src={DSBAlogo} alt="DSBA" />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h2 style={{ height: "auto" }}>
                  Function Attendance Report (Before Event)
                </h2>
              </div>
            </div>
            <div
              className="form-wrapper-vertical "
              style={{ width: "100%", marginBottom: "2rem" }}
            >
              <div className="grid-report-title-container">
                <div className="grid-report-title-item1">Event</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.EventName}
                </div>
                <div className="grid-report-title-item1">Event ID</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.UniqueEventId}
                </div>
                <div className="grid-report-title-item1">Date</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {dayjs(eventInfo.StartDateTime)?.format("DD-MMM-YYYY")}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table
                className="eventlist-table "
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="table-border">
                  <tr style={{ height: "auto", whiteSpace: "normal" }}>
                    <th style={{ width: "5%" }}>
                      <input type="checkbox" name="allselect" />
                    </th>
                    {/* <th style={{ width: "7%" }}>Judge?</th> */}
                    <th style={{ width: "25%", textAlign: "center" }}>
                      Full Name
                    </th>
                    <th style={{ width: "20%", textAlign: "center" }}>
                      Firm Name
                    </th>
                    <th style={{ width: "12%", textAlign: "center" }}>
                      Date Paid
                    </th>
                    <th style={{ width: "15%", textAlign: "center" }}>Guest</th>
                    <th style={{ width: "8%", textAlign: "center" }}>#Guest</th>
                    <th style={{ width: "15%", textAlign: "center" }}>
                      Comments
                    </th>
                  </tr>
                </thead>
                <tbody className="table-border">
                  {funcAttendanceReportBeforeEvent &&
                    funcAttendanceReportBeforeEvent.map(
                      (reportLineItem: any) => (
                        <tr style={{ height: "auto", whiteSpace: "normal" }}>
                          <td style={{ width: "2%" }}>
                            <input type="checkbox" />
                          </td>
                          {/* <td style={{ width: "8%" }}>
                      <input type="checkbox" />
                    </td> */}
                          <td
                            style={{
                              width: "20%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.LastName
                              ? reportLineItem.LastName
                              : null}
                            ,{" "}
                            {reportLineItem && reportLineItem.FirstName
                              ? reportLineItem.FirstName
                              : null}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.FirmName
                              ? reportLineItem.FirmName
                              : null}
                          </td>
                          <td
                            style={{
                              width: "12%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.DatePaid
                              ? dayjs(reportLineItem.DatePaid)?.format("DD-MMM-YYYY")
                              : null}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          ></td>
                          <td
                            style={{
                              width: "8%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          ></td>
                          <td
                            style={{
                              width: "15%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          ></td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="section-box" ref={AfterReportRef}>
            <div
              className="grid-report-header-container"
              style={{ alignItems: "center", marginBottom: "2rem" }}
            >
              <div>
                <img className="logo-img " src={DSBAlogo} alt="DSBA" />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <h2 style={{ height: "auto" }}>
                  Function Attendance Report (After Event)
                </h2>
              </div>
            </div>
            <div
              className="form-wrapper-vertical "
              style={{ width: "100%", marginBottom: "2rem" }}
            >
              <div className="grid-report-title-container">
                <div className="grid-report-title-item1">Event</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.EventName}
                </div>
                <div className="grid-report-title-item1">Event ID</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {eventInfo.UniqueEventId}
                </div>
                <div className="grid-report-title-item1">Date</div>
                <div>:</div>
                <div className="grid-report-title-item2">
                  {dayjs(eventInfo.StartDateTime)?.format("DD-MMM-YYYY")}
                </div>
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <table
                className="eventlist-table "
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="table-border">
                  <tr
                    style={{
                      height: "auto",
                      whiteSpace: "normal",
                    }}
                  >
                    <th style={{ width: "20%", textAlign: "center" }}>
                      Full Name
                    </th>
                    <th style={{ width: "20%", textAlign: "center" }}>
                      Firm Name
                    </th>
                    <th style={{ width: "12%", textAlign: "center" }}>
                      Date Paid
                    </th>
                    <th style={{ width: "10%", textAlign: "center" }}>Guest</th>
                    <th style={{ width: "10%", textAlign: "center" }}>
                      Attendance
                    </th>
                    <th style={{ width: "7%", textAlign: "center" }}>DE</th>
                    <th style={{ width: "7%", textAlign: "center" }}>DE-En</th>
                    <th style={{ width: "7%", textAlign: "center" }}>PA</th>
                    <th style={{ width: "7%", textAlign: "center" }}>PA-En</th>
                    <th style={{ width: "7%", textAlign: "center" }}>NJ</th>
                    <th style={{ width: "7%", textAlign: "center" }}>NJ-En</th>
                  </tr>
                </thead>
                <tbody className="table-border">
                  {funcAttendanceReportAfterEvent &&
                    funcAttendanceReportAfterEvent.map(
                      (reportLineItem: any) => (
                        <tr style={{ height: "auto", whiteSpace: "normal" }}>
                          <td
                            style={{
                              width: "20%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.LastName
                              ? reportLineItem.LastName
                              : null}
                            ,{" "}
                            {reportLineItem && reportLineItem.FirstName
                              ? reportLineItem.FirstName
                              : null}
                          </td>
                          <td
                            style={{
                              width: "15%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.FirmName
                              ? reportLineItem.FirmName
                              : null}
                          </td>
                          <td
                            style={{
                              width: "12%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.DatePaid
                              ?  dayjs(reportLineItem.DatePaid).format(
                                  "DD-MMM-YYYY"
                                ) 
                              : null}
                          </td>
                          <td
                            style={{
                              width: "10%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.IsGuest
                              ? "Yes"
                              : "No"}
                          </td>
                          <td
                            style={{
                              width: "10%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {reportLineItem && reportLineItem.IsAttended
                              ? "Present"
                              : "Absent"}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.DECredits
                              ? reportLineItem.DECredits
                              : null}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.DEEnchEthics
                              ? reportLineItem.DEEnchEthics
                              : null}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.PACredits
                              ? reportLineItem.PACredits
                              : null}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.PAEthics
                              ? reportLineItem.PAEthics
                              : null}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.NJCredits
                              ? reportLineItem.NJCredits
                              : null}
                          </td>
                          <td
                            style={{
                              width: "7%",
                              overflow: "wrap",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {reportLineItem && reportLineItem.NJEthics
                              ? reportLineItem.NJEthics
                              : null}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default FuncAttendanceReport;
